import React, { Component } from 'react';
import { Handle, Position, NodeResizer, useReactFlow } from '@xyflow/react';

class RectangleNodeInner extends Component {
    handleDoubleClick = (event) => {
        if (this.props.data?.onDoubleClick) {
            this.props.data.onDoubleClick(event, this.props);
        }
    };

    render() {
        const { data } = this.props;
        const label = data.label || '';
        const handleDiameter = 5;
        const handleColor = '#fff';
        const isConnectable = true;

        var handleStyle = {
            width: handleDiameter,
            height: handleDiameter,
            minWidth: handleDiameter,
            minHeight: handleDiameter,
            maxWidth: handleDiameter,
            maxHeight: handleDiameter,
            background: handleColor,
            zIndex: 1
        }

        return (
            <div 
                onDoubleClick={this.handleDoubleClick}
                style={{
                    cursor: 'pointer',
                    width: '100%',
                    height: '100%',
                    minWidth: 200,
                    minHeight: 200,
                    display: 'flex',
                    // flexDirection: 'column',
                    // alignItems: 'center',
                    // justifyContent: 'center',
                    // boxSizing: 'border-box',
                    // position: 'relative',
                }}
            >
                <NodeResizer minWidth={30} minHeight={20} />
                <div className="custom-k3-node__handles custom-k3-node__handles-top">
                    <Handle
                        type="target"
                        id="top-1"
                        position={Position.Top}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-top"
                        style={handleStyle}
                    />
                    <Handle
                        type="target"
                        id="top-2"
                        position={Position.Top}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-top"
                        style={handleStyle}
                    />

                    <Handle
                        type="target"
                        id="top-3"
                        position={Position.Top}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-top"
                        style={handleStyle}
                    />
                </div>

                <div className="custom-k3-node__handles custom-k3-node__handles-bottom">
                    <Handle
                        type="source"
                        id="bottom-1"
                        position={Position.Bottom}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-bottom"
                        style={handleStyle}
                    />
                    <Handle
                        type="source"
                        id="bottom-2"
                        position={Position.Bottom}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-bottom"
                        style={handleStyle}
                    />

                    <Handle
                        type="source"
                        id="bottom-3"
                        position={Position.Bottom}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-bottom"
                        style={handleStyle}
                    />
                </div>

                <div className="custom-k3-node__handles custom-k3-node__handles-left">
                    <Handle
                        type="target"
                        id="left-1"
                        position={Position.Left}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-left"
                        style={handleStyle}
                    />
                    <Handle
                        type="target"
                        id="left-2"
                        position={Position.Left}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-left"
                        style={handleStyle}
                    />

                    <Handle
                        type="target"
                        id="left-3"
                        position={Position.Left}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-left"
                        style={handleStyle}
                    />
                </div>

                <div className="custom-k3-node__handles custom-k3-node__handles-right">
                    <Handle
                        type="source"
                        id="right-1"
                        position={Position.Right}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-right"
                        style={handleStyle}
                    />
                    <Handle
                        type="source"
                        id="right-2"
                        position={Position.Right}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-right"
                        style={handleStyle}
                    />

                    <Handle
                        type="source"
                        id="right-3"
                        position={Position.Right}
                        isConnectable={isConnectable}
                        className="custom-k3-node__handle custom-k3-node__handle-right"
                        style={handleStyle}
                    />
                </div>
                <div style={{ padding: 10, width: '100%', textAlign: 'center', fontWeight: 500 }}>{label}</div>
            </div>
        );
    }
}

const RectangleNode = (props) => {
    const reactFlowInstance = useReactFlow();
    return <RectangleNodeInner {...props} updateNode={reactFlowInstance.updateNode} />;
};

export default RectangleNode; 